import { createContext } from 'react';
export const SelectContext = /*#__PURE__*/createContext({
  onSelect: () => void 0
});